<template>
    <header v-if="showHeaderNav && !showExtrasModal">
        <button class="btn-icon btn-toggle-music" v-if="false">
            <SvgNote></SvgNote>
            <span class="sr-only">Musique</span>
        </button>

        <button @click="showExtras" class="btn-icon btn-extras">
            <SvgNote double></SvgNote>
            <span class="sr-only">Extras</span>
            <span class="button-text">{{score}}</span>
        </button>
        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path fill-rule="evenodd" d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z" clip-rule="evenodd"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>

    <extras
        v-if="showExtrasModal"
        @decorSelected="onDecorSelected"
        @characterSelected="onCharacterSelected"
        @packSelected="onMusicPackSelected"
        @close="closeExtras"/>

    <speech-bubble v-if="showBubble && !showExtrasModal">
        <template #default>

            <div class="nav-replay" :class="{ 'visible' : canReplayAudio }">
                <button class="btn-icon btn-replay-music" @click="replayAudio">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 88 105"><path d="M40.3077 90.8878 23 89.4876V68.4852l17.3077-2.1003S54.8462 47.4827 59 50.283v53.206c0 7.001-18.6923-12.6012-18.6923-12.6012Z"/><path fill="#fff" fill-rule="evenodd" d="M63.5268 57.6346c.2018-1.3659 1.4726-2.3096 2.8385-2.1078 3.5079.5183 8.6892 2.1995 13.0545 5.6304C83.8611 64.6479 87.5 70.0044 87.5 77.6491c0 7.6345-3.6281 13.0922-8.0365 16.7199-4.3436 3.5743-9.5067 5.4425-13.0095 6.089-1.3578.251-2.6617-.6463-2.9125-2.004-.2507-1.3578.6467-2.6617 2.0044-2.9125 2.8305-.5227 7.1674-2.0931 10.7405-5.0334 3.5083-2.8869 6.2136-7.0198 6.2136-12.859 0-5.8291-2.6945-9.8292-6.1699-12.5608-3.5514-2.7912-7.8701-4.1978-10.6955-4.6152-1.3659-.2018-2.3096-1.4726-2.1078-2.8385Zm1.6433 11.8814c.6161-1.2356 2.1172-1.7379 3.3528-1.1218 2.2448 1.1193 7.0141 3.6502 7.0141 9.2549 0 2.6925-1.129 4.9393-2.5238 6.5938-1.3781 1.6347-3.1234 2.8268-4.6796 3.4476-1.2824.5115-2.7368-.1134-3.2483-1.3959-.5116-1.2824.1134-2.7367 1.3958-3.2483.7895-.3149 1.859-1.0175 2.7093-2.0261.8336-.9888 1.3466-2.1338 1.3466-3.3711 0-2.255-1.7987-3.5604-4.2452-4.7802-1.2356-.6162-1.7378-2.1173-1.1217-3.3529ZM40.3518 31.6858c11.5327-5.1637 24.7365 2.0735 24.7365 2.0735l4.1102-9.0835s-20.111-6.7149-33.139-.5442c-13.028 6.1707-18.798 18.4283-18.798 18.4283s-4.4406-4.9398-5.7697-5.5497c-1.3291-.6098-2.44439-.1721-2.80076 5.3443-.35361 5.5125 1.31846 15.133 3.41896 15.3278 2.8957.2718 6.4481-.7263 14.1652-3.4367 3.6511-1.2808 5.3642-3.2466 2.3555-4.8765-3.0088-1.6299-5.558-2.7379-5.558-2.7379s5.7464-9.7817 17.2791-14.9454Z"/></svg>
                    <span class="sr-only">Rejouer musique</span>
                </button>
            </div>

            <div class="content-text" v-if="['intro', 'next-phrase'].includes(state)">
                <div class="inner" v-html="bubbleText"></div>
            </div>

            <div class="content-choice" v-if="state=='choose'">
                <button class="choice" @click="selectEmotion('joy')">
                    <img class="thumbnail" :src="getEmotionIcon('joy')" alt="Écureuil joyeux" />
                    {{ copydeck.emotions.joy[lang] }}
                </button>
                <button class="choice" @click="selectEmotion('fear')">
                    <img class="thumbnail" :src="getEmotionIcon('fear')" alt="Écureuil effrayé" />
                    {{ copydeck.emotions.fear[lang] }}
                </button>
                <button class="choice" @click="selectEmotion('sadness')">
                    <img class="thumbnail" :src="getEmotionIcon('sadness')" alt="Écureuil triste" />
                    {{ copydeck.emotions.sadness[lang] }}
                </button>
                <button class="choice" @click="selectEmotion('calm')">
                    <img class="thumbnail" :src="getEmotionIcon('calm')" alt="Écureuil calme" />
                    {{ copydeck.emotions.calm[lang] }}
                </button>
            </div>

            <div class="content-feedback" v-if="state=='feedback'">
                <img class="thumbnail" :src="feedbackEmotionImage" alt="Écureuil triste" />
                <div class="inner" v-html="feedback">

                </div>
            </div>

            <div class="content-text" v-if="['play','song-completed', 'restart'].includes(state)">
                <div class="inner" v-html="bubbleText"></div>
            </div>

            <div class="nav" v-if="showNav">
                <button class="previous" v-if="showPrev" @click="prevState">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 30"><path d="M2 18.464c-2.667-1.54-2.667-5.388 0-6.928L20 1.144c2.667-1.54 6 .384 6 3.464v20.784c0 3.08-3.333 5.004-6 3.464L2 18.464Z"/></svg>
                </button>
                <button class="next" v-if="showNext" @click="nextState">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 30"><path d="M24 11.536c2.667 1.54 2.667 5.388 0 6.928L6 28.856c-2.667 1.54-6-.385-6-3.464V4.608c0-3.08 3.333-5.004 6-3.464l18 10.392Z"/></svg>
                </button>
            </div>
        </template>
    </speech-bubble>


    <game1-button
        v-if="showStartButton && !showExtrasModal"
        @click="startGame"
        title="Les chemin du coeur"
        label="Débuter"></game1-button>


    <nav v-if="ready && !showExtrasModal" class="nav-prevnext">
        <router-link :to="previousPage" class="btn-icon btn-prev" v-if="showPrevPage && currentLevel == 1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
        </router-link>

        <button @click="tempPrevPage"  v-if="showPrevPage" class="btn-icon btn-prev">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
        </button>

        <button @click="nextPage" v-if="showNextPage" class="btn-icon btn-next">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 66 52"><path fill-rule="evenodd" d="M2.73 14.54c-1.86.44-3.28 2.89-2.52 9C.97 29.65.16 34.78.7 36.69c.55 1.91 1.07 3.63 12.26 1.18s19.96-4.95 19.96-4.95-3.11 13.5-2.56 16.5c.55 3 2.63 4.38 12.46-1.62 9.82-6 24.22-20.38 22.04-24.2-3-5.27-8.95-10.14-22.8-20.07-6.55-4.7-11.95-5.27-11.13 1.82.82 7.09 1.98 12.77 1.98 12.77S8.62 13.15 2.74 14.55l-.01-.01Z" clip-rule="evenodd"/></svg>
        </button>
    </nav>

    <Notes v-if="playGame" v-show="!showExtrasModal" :onClick="onClickNote" />

</template>

<script>
import SpeechBubble from "../../components/SpeechBubble";
import SvgNote from "../../components/SvgNote";
import Notes from "../../components/Notes";

export default {
    name: "Game1_Game",
    components: { SpeechBubble, SvgNote, Notes }
}
</script>

<script setup>
import { computed, ref, onMounted, onUnmounted } from "vue";

import { useMainStore }     from "../../stores/main";
import { storeToRefs }      from "pinia";
import Game1Button          from "../../components/Game1Button.vue";
import useSound          from "../../composables/useSound";
import Events               from "../../game/events/Events";
import Extras               from "../../components/Extras.vue";
import {useRouter}          from "vue-router";
import User                 from "../../game/utils/User";

let store = useMainStore();
const router = useRouter();
const { lang, score,  intros, reactions, character, characterKey, copydeck } = storeToRefs(store);

const { getPreviousPage, getCopydeckAudio, getSong, setCharacter } = store;
let previousPage = computed ( () => getPreviousPage());
let showStartButton = ref(false);

let currentLevel = ref (1);
let hasStarted = ref(false);
let showHeaderNav = ref(false);
let showExtrasModal = ref(false);
let reachLast = computed ( () => currentLevel.value >= 6);


let ready = ref(false);

let song = ref({});
let state = ref("");
let bubbleText = ref("");
let urlBubble = ref("");
let showBubble = ref(false);
let selectedEmotion = ref("");
let feedbackEmotionImage = computed ( () => `/images/emotions/${characterKey.value}-${selectedEmotion.value}.png`);
let feedback = ref("");
let feedbackAudioURL = ref("");
let isSameEmotion = ref(false);

let showPrev = ref(false);
let showPrevPage = ref(false);
let showNext = ref(false);
let showNextPage = ref(false);
let canReplayAudio= ref(false);
let fctReplayAudio = ref (null);
let objReplayAudio = ref(null);

let playGame = ref(false);
let maxTidbits = computed( () => song.value.tidbits.length);
let currentPhraseIndex = ref(0);
let currentTidbitsIndex = ref(0);
let objBeforeReloaded = {};

let showNav = computed ( () => showPrev.value || showNext.value);

let { isAudioContextReady, playSound, fadeOutAll, stopPlaying, fadeAndStopPlaying } = useSound();

let hasPlayedOnce = ref(false);


function getEmotionIcon (emotion)
{
    return `/images/emotions/${characterKey.value}-${emotion}.png`;
}


function reset ()
{
    showPrev.value = false;
    showPrevPage.value = false;
    showNext.value = false;
    showNextPage.value = false;
    playGame.value = false;
    showBubble.value = false;
    currentTidbitsIndex.value = 0;
    currentPhraseIndex.value = 0;

    song.value = getSong();

}

function showExtras ()
{
    showExtrasModal.value = true;
}

function closeExtras ()
{
    showExtrasModal.value = false;

    if (reachLast.value)
    {
        playEndGameBubble();
    }
}

function onCharacterSelected (item)
{
    let fct = () =>
    {

        let callback = null;

        if (reachLast.value)
        {
            callback = () => console.log("we should go back home here");
        }

        document.dispatchEvent(new CustomEvent(Events.ReplaceCharacter, {detail: {character: item.key, done: () => onGameReadyToContinue(callback)}}));
        emits("show-loading");
    }

    prepareLoading(fct,Events.CharacterReloaded, onReloaded);
}

function onMusicPackSelected (item)
{
    User.setPack(item.key);
}

function onDecorReplaced (item)
{
    setCharacter(item);

    if (reachLast.value)
    {

    }
}
function onDecorSelected (item)
{
    let fct = () =>
    {
        document.dispatchEvent(new CustomEvent(Events.ReplaceScene,
                                               {
                                                   detail:
                                                       {
                                                           scene: item.key,
                                                           cleared: () => {}, //setCurrentLevel(this.currentLevel),
                                                           done: () => onGameReadyToContinue( () => onDecorReplaced(item) )
                                                       }
                                               }));
        emits("show-loading");
    }

    prepareLoading(fct,Events.SceneReloaded, onReloaded);

}

function setCurrentLevel (level)
{
    if (currentLevel.value !== level)
    {
        window.dispatchEvent(new CustomEvent(Events.MoveScene, {detail: {level}}));
    }

    currentLevel.value = level;

}

function prepareLoading (fct, event, onEvent)
{
    showExtrasModal.value = false;

    objBeforeReloaded.hasStarted = hasStarted.value;
    objBeforeReloaded.showBubble = showBubble.value;
    objBeforeReloaded.showNextPage = showNextPage.value;
    objBeforeReloaded.showPrevPage = showPrevPage.value;
    objBeforeReloaded.showHeaderNav = showHeaderNav.value;

    hasStarted.value = false;
    showBubble.value = false;
    showNextPage.value = false;
    showPrevPage.value = false;
    showHeaderNav.value = false;

    document.dispatchEvent(new CustomEvent(Events.BounceCharacterOut, {detail: {callback: fct}}));
    document.addEventListener(event, onEvent);
}

function onShowStartButton ()
{

    showStartButton.value = true;
}

function tempPrevPage ()
{
    // return {name: 'play', params: { lang: lang.value, id: 1 }};

    //THIS IS SOME TEMP CODE FOR MJ TO TEST SCENE
    currentLevel.value --;
    document.dispatchEvent(new CustomEvent("route-change", {detail: {scene: "foret-" + currentLevel.value}}));
}

function nextPage ()
{
    // return {name: 'play', params: { lang: lang.value, id: 1 }};



    if (!reachLast.value)
    {

        fadeOutAll();
        playGame.value = false;
        showNextPage.value = false;
        showNext.value = false;
        showPrevPage.value = false;
        showPrev.value = false;
        currentLevel.value++;
        showBubble.value = false;

        hasPlayedOnce.value = true;
        document.dispatchEvent(new CustomEvent("route-change", {detail: {scene: "foret-" + currentLevel.value}}));
        document.dispatchEvent(new CustomEvent(Events.ChangeEmotion, {detail: {emotion: "default"}}));
    }
    else
    {
        router.push({name: "home-with-lang", params: {lang: lang.value}});
    }
}

function onClickNote()
{
    score.value = score.value + 1;

    showTidbits();
}

function showTidbits ()
{
    if ((currentTidbitsIndex.value) < maxTidbits.value)
    {

        let tidbit = song.value.tidbits[currentTidbitsIndex.value];

        currentTidbitsIndex.value++;

        bubbleText.value = formatText(tidbit.text);
        playTextAudio(tidbit.audios[lang.value].url);

        if ((currentTidbitsIndex.value) >= maxTidbits.value)
        {
            showNext.value = true;
            playGame.value = false;
        }


    }

}

function getIntro (strKey = null)
{
    if (!strKey)
    {
        let index = currentLevel.value > 1 ? 1 + (Math.random(intros.value.length - 2) >> 0) : 0;

        return intros.value[index]
    }
    else
    {
        return intros.value.find( (item) => item.context === strKey);
    }
}

function replayAudio ()
{
   if (fctReplayAudio.value)
   {
       fctReplayAudio.value();
       fctReplayAudio.value = null;
   }
}
function setTextForState ()
{
    if (["intro", "next-phrase"].includes(state.value))
    {
        let intro = getIntro();
        let phrase = intro.phrases[currentPhraseIndex.value];
        bubbleText.value = formatText(phrase.phrase);

        let url =  (phrase?.audios ?? []).find( (item) => item.character === character.value.key);

        urlBubble.value = "";

        if (url)
        {
            if (url.audios[lang.value].url)
            {
                urlBubble.value = url.audios[lang.value].url;
            }
        }


        showNext.value = true;
    }

    console.log("setTextForState", state.value, urlBubble.value);
}

function formatText (str)
{
    try
    {


        let localStr = str[lang.value];
        let characterName = character.value.name[lang.value];

        localStr = localStr.replace(/(\%CHARACTER\%)/g, characterName);

        return localStr;
    }
    catch (e)
    {
        console.log("formatText", e, str);
    }
}
function startGame (force = true)
{
    if (!force && !hasPlayedOnce.value)
    {
        return;
    }

    showStartButton.value = false;
    state.value = "pre-intro";
    hasStarted.value = true;
    showHeaderNav.value = true;

    runState();

    //startAudio();
}

function selectEmotion (emotion)
{
    selectedEmotion.value = emotion;

    isSameEmotion.value = song.value.emotion == emotion;

    let strReaction = `${song.value.emotion}-${emotion}`;
    let reaction = reactions.value.find( (item) => item.key === strReaction);

    feedback.value = reaction.text[lang.value];

    feedbackAudioURL.value = reaction.audios ? reaction.audios[lang.value]?.url : "";

    state.value = "feedback";

    runState();

}
function prevState ()
{

}

function playCharacterAnimation (animation)
{

    document.dispatchEvent(new CustomEvent(Events.PlayCharacterAnimation, {detail: {animation}}));

}

function makeReplayMethod ()
{
    fctReplayAudio.value = () => playTextAudio(objReplayAudio.value.url, objReplayAudio.value.animationDuring, objReplayAudio.value.animationAfter);
}
function playTextAudio (url, animationDuring, animationAfter)
{
    if (!url || url === "")
        return;

    canReplayAudio.value = false;
    objReplayAudio.value = {url, animationDuring, animationAfter};

   makeReplayMethod();

    playSound(url,
              "narrator",
              {
                  "delay": 750,
                  "start":
                      {
                          "type": "fade",
                          "to": 0.25,
                          "duration": 750
                      },
                  "end":
                      {
                          "type": "fade",
                          "to": 1,
                          duration: 2000
                      }
              },
              {
                  start: () => playCharacterAnimation(animationDuring),
                  end: (completed = false) =>  onNarratorEnded(animationAfter, completed)
              });

    window.dispatchEvent(new CustomEvent("maestro-talk"));
}

function onNarratorEnded (animationAfter, completed)
{
    playCharacterAnimation(animationAfter);

    window.dispatchEvent(new CustomEvent("maestro-end-talk"));

    if (completed)
    {
        console.log("onNarratorEnded")
        let btnNext = document.querySelector(".next");

        if (btnNext)
        {
            btnNext.classList.add("pulse");
        }

        canReplayAudio.value = true;
    }
}

function runState ()
{
    console.log("%c runState " + state.value, "font-size: 22px; background: #222; color: #bada55")
    if (state.value === "pre-intro")
    {
        document.dispatchEvent(new CustomEvent(Events.BounceCharacterIn, {detail: {callback: () => nextState()}}));
    }
    else if (state.value === "intro")
    {
        document.dispatchEvent(new CustomEvent(Events.ShowMaestro));

        setTimeout( ()  =>
                    {
                        startAudio();
                        setTextForState();
                        playTextAudio(urlBubble.value, {
                            type:      "sequence",
                            animation: ["listen", "listen", "listen", song.value.emotion]
                        }, "idle-1-loop");


                        showBubble.value = true;
                        showNext.value = true;
                    }, 1);
    }
    else if (state.value === "next-phrase")
    {
        setTextForState();
        playTextAudio(urlBubble.value, {type: "sequence", animation: ["listen", "listen","listen", song.value.emotion]}, "idle-1-loop");


        showBubble.value = true;
        showNext.value = true;
    }
    else if (state.value === "choose")
    {
        // showPrev.value = true;
         showNext.value = false;
        document.dispatchEvent(new CustomEvent(Events.PlayCharacterAnimation, {detail: {animation: "question"}}));
    }
    else if (state.value === "feedback")
    {
        // showPrev.value = true;
         showNext.value = true;
        playTextAudio(feedbackAudioURL.value, {animation: isSameEmotion.value ? selectedEmotion.value : "surprise", type: "pause"}, "idle-1-loop");

        document.dispatchEvent(new CustomEvent(Events.ChangeEmotion, {detail: {emotion: selectedEmotion.value}}));

    }
    else if (state.value === "play")
    {
        // showPrev.value = true;
        // showNext.value = false;
        let bubblePlay = getCopydeckAudio("game1", "click_on_notes")
        bubbleText.value = formatText(bubblePlay.data);
        playTextAudio(bubblePlay.audios[lang.value].url);

        showNext.value = false; //!(currentLevel.value < 6) ;
        showNextPage.value = false;//currentLevel.value < 6;
        playGame.value = true;

       // document.dispatchEvent(new CustomEvent(Events.ChangeEmotion, {detail: {emotion: selectedEmotion.value}}));
    }

    else if (state.value === "song-completed")
    {
        // showPrev.value = true;
        // showNext.value = false;

        let strKey = currentLevel.value < 6 ? "song_completed" : "game_completed";

        if (strKey === "song_completed")
        {
            let bubblePlay = getCopydeckAudio("game1", strKey)
            bubbleText.value = formatText(bubblePlay.data);
            playTextAudio(bubblePlay.audios[lang.value].url);

            showNextPage.value = true;
            showNext.value = false;
        }
        else //at the last level
        {
            let intro = getIntro('foret-fin');
            let phrase = intro.phrases[0];
            bubbleText.value = formatText(phrase.phrase);

            let bubblePlay =  (phrase?.audios ?? []).find( (item) => item.character === character.value.key);

            playTextAudio(bubblePlay.audios[lang.value].url);

            showNextPage.value = false;
            showNext.value = true;
        }




        fadeAndStopPlaying(["music"], {to: 0, duration: 2500});





        // document.dispatchEvent(new CustomEvent(Events.ChangeEmotion, {detail: {emotion: selectedEmotion.value}}));
    }
    else if (state.value === "game-completed")
    {
        showExtras();
        showNext.value = false;
    }
    else if (state.value === "restart")
    {
        let bubblePlay = getCopydeckAudio("game1", "restart_game")
        bubbleText.value = formatText(bubblePlay.data);
        playTextAudio(bubblePlay.audios[lang.value].url);

        showNextPage.value = true;
        showNext.value = false;

    }
}
function nextState ()
{

    let arrStates = {
        "pre-intro": "intro",
        "intro": "next-phrase",
        "next-phrase": "choose",
        "choose": "feedback",
        "feedback": "play",
        "play": "song-completed",
        "song-completed": "game-completed",
        "game-completed": "restart",
    }

    if (!(state.value in arrStates))
        return;

    canReplayAudio.value = false;

    if (["intro", "next-phrase"].includes(state.value))
    {
        currentPhraseIndex.value++;
    }

    if (state.value === "next-phrase")
    {
        let intro = getIntro();

        if (currentPhraseIndex.value < (intro?.phrases ?? []).length)
        {
            runState();
            return;
        }

    }

    state.value = arrStates[state.value];

    // if (state.value === "intro")
    // {
    //     state.value = "choose";
    // }
    // else if (state.value === "choose")
    // {
    //     state.value = "feedback";
    // }
    // else if (state.value === "feedback")
    // {
    //     state.value = "play";
    // }
    // else if (state.value === "play")
    // {
    //     state.value = "song-completed";
    //
    //
    // }

    runState();
}

function startAudio ()
{
    let url = song?.value?.audio?.url ?? "";

    console.log(url);

    playSound(url, "music", {init:{loop: true}})

    ready.value = true;
}

function onGameReadyToContinue (fct)
{
    const gotAudioContext = isAudioContextReady();

    console.log("gotAudioContext", gotAudioContext);

    if (fct)
    {
        fct();
    }

    if (!gotAudioContext)
    {
        onShowStartButton();
    }
    else
    {

        reset();
        startGame();
    }
}


function onReloaded (event)
{
    const gotAudioContext = isAudioContextReady();

    setTextForState();

    if (fctReplayAudio.value)
    {
        objReplayAudio.value.url = urlBubble.value;
        makeReplayMethod();
    }

    if (!gotAudioContext)
    {
        onShowStartButton();
    }
    else
    {


        document.dispatchEvent(new CustomEvent(Events.BounceCharacterIn, {detail: {callback: () => continueAfterReloaded()}}));
    }
}

function continueAfterReloaded ()
{
    hasStarted.value = objBeforeReloaded.hasStarted;
    showBubble.value = objBeforeReloaded.showBubble;
    showNextPage.value = objBeforeReloaded.showNextPage;
    showPrevPage.value = objBeforeReloaded.showPrevPage;
    showHeaderNav.value = objBeforeReloaded.showHeaderNav;

    if (reachLast.value)
    {
        closeExtras();
        //router.push({name: "home-with-lang", params: {lang: lang.value}});
    }
}

function playEndGameBubble ()
{
    console.log("playEndGameBubble");
    nextState();
}


onMounted ( () =>
            {

                onGameReadyToContinue( () => {});
            });

onUnmounted ( () =>
              {
                  fadeAndStopPlaying("music");
                  fadeAndStopPlaying("narrator");
                  state.value = "pre-intro"
              });

defineExpose({ reset, startGame })
let emits = defineEmits(["show-loading", "restartAt"])

</script>

